import {createSlice, current} from "@reduxjs/toolkit";
import Sensor from "../../models/Sensor";

/**
 * Sensor Slice
 * - Takes in sensor objects in db format
 * - Stores sensor objects in frontend format
 * - stores data as dict of dict:
 * data: { sensorId1: {Sensor obj 1},
 *         sensorId2: {Sensor obj 2},
 *         ...
 *       }
 */
const initialState = {
  loading: false,
  data: {},
  error: "",
};

const sensorSlice = createSlice({
  name: "sensor",
  initialState,

  reducers: {
    addSensor: (state, action) => {
      let newSensor = {
        sensorId: action.payload.sensorId,
        roomId: action.payload.roomId,
        sensorName: action.payload.sensorName,
        sensorType: action.payload.sensorType,
        status: null,
      };
      state.data[action.payload.sensorId] = newSensor;
    },
    updateSensor: (state, action) => {
      let sid = action.payload.sensor_id;
      if (!state.data[sid]) return;
      let copy = {...current(state.data)};
      let updateSensor = {...copy[sid]};
      updateSensor.status = action.payload.status;
      updateSensor.updateTime = action.payload.update_time;
      copy[sid] = updateSensor;
      state.data = copy;
    },
    updateSensorData: (state, action) => {
      let sid = action.payload.sensorId;
      let copy = {...current(state.data)};

      let updateSensor = {...copy[sid]};

      updateSensor.sensorName = action.payload.sensorName;
      updateSensor.sensorType = action.payload.sensorType;
      copy[sid] = updateSensor;
      state.data = copy;
    },
    deleteSensor: (state, action) => {
      const key = action.payload.sensorId;
      delete state.data[key];
    },
    setSensor: (state, action) => {
      let sensorList = action.payload;
      let sensorDict = {};
      for (let sensor of sensorList) {
        sensor = JSON.parse(JSON.stringify(new Sensor(sensor)));
        sensorDict[sensor.sensorId] = sensor;
      }
      state.data = sensorDict;
    },
  },
});

export const {
  setSensor,
  addSensor,
  updateSensor,
  updateSensorData,
  deleteSensor,
  updateSensorCurrCount,
  updateSensorCumulativeCount,
} = sensorSlice.actions;

export default sensorSlice.reducer;
